import { Component, OnInit, Input } from '@angular/core';
import { FormatoAsistencialEntity, FiltrosFormatoAsistencialEntity, NodoEntity, ServicioFormatoAsistencialService } from 'src/app/services/servicio-formato-asistencial.service';
import { ObjetoImagenesEntity } from 'src/app/services/servicio-imagenes.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-audiometria-tonal',
  templateUrl: './audiometria-tonal.component.html',
  styleUrls: ['./audiometria-tonal.component.css']
})
export class AudiometriaTonalComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() nodo: NodoEntity;

  titulo: string;
  img: string;

  constructor( private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.getImagen();
  }

  getTypeOido() {
    const valor = this.nodo.valor;
    switch(valor) {
      case '1': return 'OD';
      case '2': return 'OI';
      default: return '';
    }
  }

  async getImagen() {
    const request = await this.servicioFormato.getImagenNodo(this.filtros.codigoBaseDatos, this.filtros.entidadEmpresarial.unco, this.filtros.tta, this.nodo.id);
    request.subscribe((data: any) => {
      this.img = data.source;
    }, (err: HttpErrorResponse) => {
      this.img = null;
      console.error('Error Audiometria Tonal', err);
    })
  }

  getPTA(): string {
    const dato = this.nodo.datos && this.nodo.datos.length > 0 ? this.nodo.datos[0] : null;
    if (dato) {
      const valor = dato.valor;
      if (valor) {
        const json = JSON.parse(valor);
        return json ? json.pta : '--';
      }
    }
    return '--';
  }

}
